export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=700e22d5d6098f31210c72359c4ed79e408f9c4cd2&name=pushAdClickData!'